import * as usersApi from '@/services/rest-api-sms/lib/users/users'
import Vue from 'vue';

export const state = {
  users: [],
  loadingTechnician: false,
  autoReload: true,
  userTrafficControl: true,
  userCluster: true,
  markerPlate: true,
  markerLabel: true,
  markerLabelLayout: true,
  user: null,
  technicians: [], // array of { id, name, area, address, latitude, longitude, geofenceType, radius 
}

export const mutations = {
  SET_USERS(state, payload) {
    state.users = payload
  },

  UPDATE_USER(state, payload) {
    const { userId, customer, actualInstall } = payload;
    const user = state.users.find(user => user.userId === userId);
    if (user) {
      user.customer = customer;
      user.actualInstall = actualInstall;
    }
  },

  SET_USER(state, payload) {
    state.user = payload
  },

  loadingTechnician(state, payload) {
    state.loadingTechnician = payload
  },

  loadingHistory(state, payload) {
    state.loadingHistory = payload
  },

  autoReload(state, payload) {
    state.autoReload = payload
  },

  userTrafficControl(state, payload) {
    state.userTrafficControl = payload
  },

  userCluster(state, payload) {
    state.userCluster = payload
  },

  markerPlate(state, payload) {
    state.markerPlate = payload
  },

  markerLabel(state, payload) {
    state.markerLabel = payload
  },

  markerLabelLayout(state, payload) {
    state.markerLabelLayout = payload
  },

  SET_TECHNICIANS(state, list) {
    state.technicians = list;
  },

  UPDATE_TECHNICIAN(state, updatedTech) {
    const index = state.technicians.findIndex(t => t.user_id == updatedTech.user_id);
    if (index !== -1) {
      const newTech = {
        ...state.technicians[index],
        ...updatedTech,
        address: {
          ...(state.technicians[index].address || {}),
          ...(updatedTech.address || {})
        }
      };
      Vue.set(state.technicians, index, newTech);
    }
  }
}

export const actions = {
  async fetchUser({ state, commit }, userId) {
    // ⛔ STOP kalau user sudah ada
    if (state.user) return

    const params = {
      page: 1,
      limit: 1,
      filters: [`user_id eq ${userId}`],
    }

    return usersApi.get(params).then((res) => {
      const user = res.data?.paginated_result?.[0]

      if (user) {
        commit('SET_USER', user)
      }

      return res
    })
  },

  async loadTechnicians({ state, commit }) {
    let technicians = []
    if (state.technicians.length > 0) technicians = state.technicians
    else technicians = await usersApi.getTechnicians();
    const normalized = technicians.map(t => ({
      ...t,
      address: t.address ?? { area: 'West', address: null, latitude: null, longitude: null }
    }));
    commit('SET_TECHNICIANS', normalized);
  },

  async updateTechnician(_, { userId, payload }) {
    return usersApi.saveAddress(userId, payload);
  },
}
